<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        支店管理 - 新規登録
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>
      <form name='addForm' v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報【必須】
            </div>
            <div class="inputTitle" style="display: flex;">
              支店名
            </div>
            <div class="row">
              <validation-provider name="支店名" rules="required|max:255" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.branchName" style="width: 500px;" placeholder="渋谷支店">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              アカウント情報【必須】
            </div>
            <div class="inputTitle" style="display: flex;">
              ログインID
            </div>
            <div class="row">
              <validation-provider name="ログインID" rules="required|min:4|max:96|loginId" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.loginId"  style="width: 500px;" placeholder="xxxxxx@xxx.xxx" readonly>
                  <div v-if="idCheckFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
                    <div　class="errMsg">
                      <div class="errDiv">
                        既に登録されているログインIDです.</br>
                        新しく取得したログインIDで再度ご登録をお願い致します．
                      </div>
                    </div>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              メールアドレス
            </div>
            <div class="row">
              <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.email"  style="width: 500px;" placeholder="xxxxxx@xxx.xxx">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              パスワード
            </div>
            <div class="row">
              <validation-provider name="パスワード" rules="required|min:8|max:64|password" vid="confirmation" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.password"
                    style="width: 500px;" placeholder="ご希望のパスワード(8文字以上の半角英数記号)">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              パスワード確認
            </div>
            <div class="row">
              <validation-provider name="パスワード確認" rules="required|confirmed:confirmation|min:8|max:64|password" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.confirm"
                   style="width: 500px;" placeholder="先ほど入力したパスワードを再度入力">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="buttonGroup">
            <button class="btn" @click="confirm(detail)" type = "button"
            v-bind:class="{ disabled:isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
            :disabled="ObserverProps.invalid">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: '支店登録',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  data() {
    return {
      num: '',
      detail: {
        loginId: '',
        companyId: '',
        branchName: '',
        email: '',
        password: '',
        confirm: '',
      },
      // ローディング
      getLodingFlg: false,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false,  // データ登録時エラーフラグ
      errorMessage: '',
      idCheckFlg: false,
    };
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  async mounted() {
    try {
      const session = this.$store.getters.session;
      this.getLodingFlg = true;
      // セッション情報からログイン事業者IDを取得
      this.detail.companyId = session.companyId;
      await this.callGetNumbering();
      const number =  (('00000' + this.num).slice(-5));
      this.detail.loginId = session.loginId + number;
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  methods: {
    // ナンバリング取得
    async callGetNumbering() {
      const key = this.$store.getters.session.loginId;
      // 採番取API
      const restResourceService = new ApiClient();
      this.num = await restResourceService.getNumbering(key);
    },
    // ログインID重複チェック
    async callGetLoginIdcheck() {
      // 採番取API
      const restResourceService = new ApiClient();
      this.idCheckFlg = await restResourceService.getLoginIdcheck(this.detail.loginId);
    },
    // ナンバリング更新
    async callUpdateNumbering() {
      const key = this.$store.getters.loginId;
      // 採番更新API
      const restResourceService = new ApiClient();
      await restResourceService.updateNumbering(key);
    },
    // 登録ボタン押下時処理
    async confirm(detail) {
      // 採番重複チェック
      try {
        // ボタン非活性化
        this.startProcessing();
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        // 採番重複チェック
        await this.callGetLoginIdcheck();
        // ログインIDが重複していた場合
        if (this.idCheckFlg) {
          await this.callGetNumbering();
          const number =  (('00000' + this.num).slice(-5));
          this.detail.loginId = this.$store.getters.session.loginId + number;
          return;
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.postErrorFlg = true;
      } finally {
        // ローディング非表示
        this.postLodingFlg = false;
      }
      // ====================入力項目空白削除====================
      detail.branchName = detail.branchName.trim();
      // ====================API呼出====================
      try {
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        // cognitoへ支店管理者権限アカウントを新規登録
        await this.$cognito.signUp(detail.loginId, detail.email, detail.password, '5');
        await this.$cognito.setUserPassword(detail.loginId, detail.email, detail.password);
        // 支店登録API呼出
        const bodies = [];
        const body = {
           branchName: detail.branchName,
           loginId: detail.loginId,
           email: detail.email,
           companyId: detail.companyId,
           password: detail.password,
        };
        bodies.push(body);
        const restResourceService = new ApiClient();
        // 支店新規登録API呼出
        await restResourceService.postBranch(bodies);
        // await this.callUpdateNumbering();
        this.screenTransition();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 画面遷移
    screenTransition() {
      history.back();
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
    async isProcessing() {
      return this.processing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 500px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 500px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
